namespace Areas {
    "use strict";

    export function addToFavorite(e: any) {
        const dialog = new Areas.Dialogs.CreateFavoriteDialog(() => { }, { favoriteName: e.component.option("description") });
    }


}